@for (series of series | keyvalue; track series) {
  <div>
    <zwi-sermon-category-row>{{ series.key }}</zwi-sermon-category-row>
    <zwi-sermon-list [bookmarkable]="bookmarkable" [sermons]="series.value" [sortBy]="'airDate'" (starChange)="favoriteChange($event)"></zwi-sermon-list>
  </div>
}
